const root = `td-resource/logRecord`
const urls = {
  getDetail: root + '/detail',
  getList: root + '/page',
  remove: root + '/remove',
  add: root + '/submit',
  update: root + '/submit'
}
// 查看详情
export const getDetail = id => {
  return $http.get(`${urls.getDetail}?id=${id}`)
}
// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 新增
export const add = obj => {
  return $http.post(urls.add, obj)
}
// 更新
export const update = obj => {
  return $http.post(urls.update, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}
export default {
  getDetail,
  getList,
  add,
  update,
  remove
}
